import { MAX_ENTITY_REF_IDS } from '@orn/global/assistant/inlineMarkup.js';

import type { IConversationMessage } from '../../hooks/useAssistantWebSocket';

/**
 * The alerts a transcript's cards name, deduped and in a stable order.
 *
 * Deduped because rehydrated history can hold more than one card for the same
 * alert, from before the strip's guard existed. Neither live path produces one:
 * the strip reads this very list and refuses a second expand while a card is
 * present, and a turn that fails takes its card back down with the rest of its
 * rows, so the retry that follows leaves one card rather than two. Sorted so a
 * re-render that
 * reorders nothing produces identical query variables and hits the Apollo cache
 * instead of refetching.
 *
 * Capped at {@link MAX_ENTITY_REF_IDS}, which is the page size the read clamps
 * to: asking for more returns one page anyway, so the excess is dropped here
 * where it is visible rather than silently truncated server-side. A transcript
 * with that many distinct cards is far past any real session.
 */
export function collectAlertCardIds(messages: readonly IConversationMessage[]): string[] {
  const ids = new Set<string>();
  for (const message of messages) {
    if (message.kind === 'alert-card' && message.alertId !== undefined) {
      ids.add(message.alertId);
    }
  }
  return [...ids].toSorted().slice(0, MAX_ENTITY_REF_IDS);
}
